import jobRoles from './job-roles.json';

export const getJobRoleFromSlug = (slug?: string): string => {
  const rolesToExclude = [
    'manager',
    'fahrer',
    'arzt',
    'kws',
    'dj',
    'cco',
    'ceo',
    'cra',
    'cio',
    'cto',
    'cta',
    'cfo',
  ];
  let jobRole = '';

  jobRoles.roles.forEach((role) => {
    if (slug?.includes(role) && !rolesToExclude.includes(role)) {
      jobRole = role;
    }
  });

  return jobRole;
};
